import { Component } from '@angular/core';
import { SparePartsApiService } from 'src/app/api/spareParts/sparePartsApiService';
import { SparePartsImportResponse } from 'src/app/api/spareParts/sparePartsImportResponse';
import { mapImportErrors } from 'src/app/utils/error-utils';

@Component({
    selector: 'import-spare-parts',
    templateUrl: './import-spare-parts.component.html',
    styleUrls: ['./import-spare-parts.component.css'],
    standalone: false
})
export class ImportSparePartsComponent {
  validationInProgress: boolean = false;
  uploadInProgress: boolean = false;
  errors: string[] = [];
  uploadResponse: SparePartsImportResponse | null = null; //server response - for debugging
  canUpload: boolean = false;
  formData: FormData | null = null;
  uploadFinished: boolean = false;
  fileName: string = '';

  constructor(
    private sparePartsApiService: SparePartsApiService
  ) { }

  fileInputChange(fileInputEvent: any) {
    this.validationInProgress = true;
    this.canUpload = false;
    this.errors = [];
    this.uploadResponse = null;
    this.uploadFinished = false;
    this.fileName = fileInputEvent.target.files[0].name;

    this.formData = new FormData();
    this.formData.append('file', fileInputEvent.target.files[0]);
    this.formData.append('shouldValidateOnly', 'true');

    this.sparePartsApiService.importSpareParts(this.formData)
      .subscribe({
          next: response => {
            this.validationInProgress = false;
            this.errors = [];
            this.uploadResponse = response;
            this.canUpload = true;
          },
          error: error => {
            this.validationInProgress = false;
            this.errors = mapImportErrors(error.error.Message, error.error.Errors);
            this.canUpload = false;
            this.uploadResponse = error;
          }
        });
  }

  executeUpload() {
    if(this.formData == null) {
      console.error('No file selected');
      return;
    }

    this.formData.delete('shouldValidateOnly');
    this.formData.append('shouldValidateOnly', 'false');
    this.uploadInProgress = true;

    this.sparePartsApiService.importSpareParts(this.formData)
    .subscribe({
        next: response => {
          this.uploadInProgress = false;
          this.uploadResponse = response;
          this.uploadFinished = true;
          this.canUpload = false;
        },
        error: error => {
          this.uploadInProgress = false;
          this.errors = mapImportErrors(error.error.Message, error.error.Errors);
          this.uploadResponse = error;
        }
      });
  }
}
